import OrdersWorkspace from "./components/orders/OrdersWorkspace"

const OrdersContainer = ({ groupOnly = false }) => (
  <OrdersWorkspace
    role="manager"
    defaultTab={groupOnly ? "grouped" : "all"}
    allowGroupOrders
  />
)

export default OrdersContainer
